import { AuthApiService } from '../../../services/AuthApiService';
import { ENROLLED_STATUS, EMAIL_TYPE, PHONE_TYPE, AUTH_APP } from '../../../utils/constants';

const _apiService = new AuthApiService();

export const getDeviceType = (defaultDeviceId, emailInfoId, appInfoId, phoneInfoId) => {
  let device;
  switch (defaultDeviceId) {
    case emailInfoId:
      device = EMAIL_TYPE;
      break;
    case phoneInfoId:
      device = PHONE_TYPE;
      break;
    case appInfoId:
      device = AUTH_APP;
      break;
  }
  return device;
}

export const getAndCleanDevice = (devices) => {
  let activeDevice;
  devices?.sort((a, b) => new Date(a.meta?.lastModified) - new Date(b.meta?.lastModified)).forEach(device => {
    // Use last device resource with ENROLLED status
    if (device.authenticationFactors?.some(af => af.status === ENROLLED_STATUS)) {
      if (activeDevice) { // If there is previous active device, remove it as well
        _apiService.deleteMyDevice(activeDevice.id);
      }

      activeDevice = device;
    }
    // If device resource is not enrolled, remove it
    else {
      _apiService.deleteMyDevice(device.id);
    }
  });
  return activeDevice;
};

export const formatPhoneNumber = (phoneNumberString) => {
  const cleaned = ('' + phoneNumberString).replace(/\D/g, '');
  const match = cleaned.match(/^(1|)?(\d{3})(\d{3})(\d{4})$/);
  if (match) {
    const intlCode = match[1] ? '+1 ' : '';
    return [intlCode, '(', match[2], ') ', match[3], '-', match[4]].join('');
  }
};
